import React, { useMemo } from "react";
import { Divider, Grid } from "@material-ui/core";
import { Championship, convertToClasses } from "api/model/Championship";
import { useFormikContext } from "formik";
import {
    SelectFieldFormik,
    SelectOption,
} from "ui/componentes/Form/SelectFieldFormik";
import { Subtitle } from "ui/componentes/Layout";
import { BoxCard } from "ui/componentes/BoxCard";
import { useCollection } from "api/hooks/useCollection";
import { Collections } from "api/model/Collections";
import { PointsByRaceConfiguration } from "api/model/PointsByRaceConfiguration";

const ChampionshipPointingForm = () => {
    const {
        values,
        setFieldValue,
        setFieldTouched,
    } = useFormikContext<Championship>();

    const pointsByRaceConfig = useCollection<PointsByRaceConfiguration[]>(
        { collection: Collections.POINTS_BY_RACE_CONFIG },
        true
    );
    const pointsByRaceConfigOptions = useMemo(
        () =>
            pointsByRaceConfig
                .sort((c1, c2) => (c1.name < c2.name ? -1 : 1))
                .map<SelectOption>((config) => ({
                    label: config.name,
                    value: config.id,
                })),
        [pointsByRaceConfig]
    );
    const pointsConfigById = useMemo(() => {
        const pointsConfigById = {};
        pointsByRaceConfig.forEach(
            (config) => (pointsConfigById[config.id] = config.pointsByPositions)
        );
        return pointsConfigById;
    }, [pointsByRaceConfig]);

    const classes = useMemo(() => {
        return convertToClasses(values.cars);
    }, [values.cars]);

    return (
        <Grid container spacing={5}>
            {values.raceConfigurations.map((raceConfig, indexConfig) => {
                return (
                    <Grid container spacing={1} item xs={12} key={indexConfig}>
                        <Grid item xs={12}>
                            <Subtitle text={`BATERIA ${indexConfig + 1}`} />
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        {classes.map((carClass, index) => (
                            <Grid item md={4} xs={12} key={index}>
                                <BoxCard
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    padding={2}
                                >
                                    <Subtitle
                                        text={
                                            carClass.name ||
                                            carClass.id ||
                                            "Sem classe definida"
                                        }
                                        color="textSecondary"
                                    />
                                    <Divider
                                        style={{
                                            marginBottom: 20,
                                            marginTop: 5,
                                            width: "100%",
                                        }}
                                    />
                                    <SelectFieldFormik
                                        id={`raceConfigurations.${indexConfig}.pointSystem.key_${carClass.id}`}
                                        name={`raceConfigurations.${indexConfig}.pointSystem.key_${carClass.id}`}
                                        onChange={(value) => {
                                            const fieldName = `raceConfigurations.${indexConfig}.pointSystem.key_${carClass.id}`;
                                            setFieldTouched(fieldName, true);
                                            if (value.target.value) {
                                                setFieldValue(
                                                    fieldName,
                                                    pointsConfigById[
                                                        value.target.value
                                                    ]
                                                );
                                                return;
                                            }
                                        }}
                                        label="Sistema de pontução"
                                        options={pointsByRaceConfigOptions}
                                    />
                                    <Grid
                                        container
                                        spacing={1}
                                        style={{
                                            padding: 4,
                                            marginTop: 2,
                                        }}
                                    >
                                        {raceConfig.pointSystem &&
                                            raceConfig.pointSystem[
                                                `key_${carClass.id}`
                                            ] &&
                                            raceConfig.pointSystem[
                                                `key_${carClass.id}`
                                            ].map((pp) => (
                                                <Grid
                                                    item
                                                    xs={4}
                                                    key={pp.position}
                                                >
                                                    <Subtitle
                                                        text={`${pp.position}º - ${pp.points}`}
                                                    />
                                                </Grid>
                                            ))}
                                    </Grid>
                                </BoxCard>
                            </Grid>
                        ))}
                    </Grid>
                );
            })}
        </Grid>
    );
};

export { ChampionshipPointingForm };
